<app-base-page pageTitle="Workflow Engine History"
	[pageContext]="pageContext"
	utilityMenuOperationGroupName="">

	<div #AdditionalHeaderContent
		additional-header-content
		*ngIf="!loadingTableDefinitions">
		<app-information-menu
			[informationMenuItems]="informationMenuItems">
		</app-information-menu>
	</div>

	<div *ngIf="loadingTableDefinitions"
		class="text-center ui-g-12">
		<span class="fa fa-fw fa-spin fa-spinner theme-color double-font-size">
		</span>
	</div>

	<div *ngIf="!loadingTableDefinitions"
		class="ui-g-12 table-container">
		<app-common-table
			[tableDefinitions]="tableDefinitions">
		</app-common-table>
	</div>

</app-base-page>